import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
// UI Libraries
import { Button, Container } from "reactstrap";
// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
// Redux
import { useSelector } from "react-redux";
// Language, Static Datas and Assets
import logoSm from "assets/images/logos/logo-trive-sm.png";
import logoTrivePartnerLight from "assets/images/logos/logo-trive-partner-light.svg";
import logoTriveLight from "assets/images/logos/logo-trive-dark.svg";
import logoInvestDark from "assets/images/logos/logo-trive-invest-light.png";
import img5 from "assets/images/campaign/camp-5.png";
import img6 from "assets/images/campaign/camp-6.png";
import img7 from "assets/images/campaign/camp-7.png";
import { userTypes } from "constants/layout";
// Components
import VerticalLayout from "./VerticalLayouts";
import CampaignCard from "Components/Common/CampaignCard";
// Helpers and Hooks
import {
  isInvestCompany,
  isMalaysiaCompany,
} from "helpers/Others/company_helper";
import { useGlobalHooks } from "hooks/useGlobalHooks";
import { RiArrowLeftSLine, RiArrowRightSLine, RiRecordCircleLine } from "react-icons/ri";

const Sidebar = ({ layoutType }: any) => {
  const { t } = useGlobalHooks();
  const [isInvest, setIsInvest] = useState(false);
  const [isMalaysia, setIsMalaysia] = useState(false);

  useEffect(() => {
    (async () => {
      const invest = await isInvestCompany();
      setIsInvest(invest);
      const malaysia = await isMalaysiaCompany();
      setIsMalaysia(malaysia);
    })();
  }, []);

  const currentLanguage: any = sessionStorage.getItem("I18N_LANGUAGE");

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);

  const { authData } = useSelector((state: any) => state.Dashboard);

  const [dir, setDir] = useState("ltr");

  useEffect(() => {
    setDir(document.documentElement.getAttribute("dir") || "ltr");
  }, [currentLanguage]);

  const getCampaignRedirectUrl = (id: number) => {
    let lang =
      (currentLanguage?.includes("-")
        ? currentLanguage.split("-")[0]
        : currentLanguage) || "en";

    if (id === 1) {
      return (
        redirectWelcomeBonusUrls?.[lang] ||
        "https://www.trive.com/int/promotions/first-deposit-bonus" ||
        "/"
      );
    } else if (id === 2) {
      return (
        redirectDepositBonusUrls?.[lang] ||
        "https://www.trive.com/int/promotions/20-deposit-bonus" ||
        "/"
      );
    }
  };

  const redirectWelcomeBonusUrls: { [key: string]: string | undefined } = {
    zh: "https://www.trivechina.com/promotions/first-deposit-bonus",
    TW: "https://www.trive.com/int-tw/promotions/first-deposit-bonus?redirect=false",
    HI: "https://www.trive.com/int-hi/promotions/first-deposit-bonus?redirect=false",
    th: "https://www.trive.com/int-th/campaign/first-deposit-bonus?redirect=false",
    vi: "https://www.trivevietnam.com/campaign/first-deposit-bonus",
    KR: "https://www.trive.com/int-kr/promotions/first-deposit-bonus?redirect=false",
    tl: "https://www.trive.com/int-ph/promotions/first-deposit-bonus?redirect=false",
    es: "https://www.trive.com/int-es/promotions/first-deposit-bonus?redirect=false",
    ja: "https://www.trive.com/int-jp/promotions/first-deposit-bonus?redirect=false",
    ar: "https://www.trive.com/int-ar/promotions/first-deposit-bonus?redirect=false",
  };

  const redirectDepositBonusUrls: { [key: string]: string | undefined } = {
    zh: "https://www.trivechina.com/promotions/20-deposit-bonus",
    TW: "https://www.trive.com/int-tw/promotions/20-deposit-bonus?redirect=false",
    HI: "https://www.trive.com/int-hi/promotions/20-deposit-bonus?redirect=false",
    th: "https://www.trive.com/int-th/promotions/20-deposit-bonus?redirect=false",
    vi: "https://www.trivevietnam.com/promotions/20-deposit-bonus",
    KR: "https://www.trive.com/int-kr/promotions/20-deposit-bonus?redirect=false",
    tl: "https://www.trive.com/int-ph/promotions/20-deposit-bonus?redirect=false",
    es: "https://www.trive.com/int-es/promotions/20-deposit-bonus?redirect=false",
    ja: "https://www.trive.com/int-jp/promotions/20-deposit-bonus?redirect=false",
    ar: "https://www.trive.com/int-ar/promotions/20-deposit-bonus?redirect=false",
  };

  const campaignSliderDatas = [
    // {
    //   id: 1,
    //   contentText: `${t("welcomebonus")}`,
    //   buttonText: t("learnmore"),
    //   image: img6,
    //   url: getCampaignRedirectUrl(1),
    //   target: "_blank",
    // },
    // {
    //   id: 2,
    //   contentText: `${t("depositbonus")}`,
    //   buttonText: t("learnmore"),
    //   image: img7,
    //   url: getCampaignRedirectUrl(2),
    //   target: "_blank",
    // },
    {
      id: 3,
      contentText: t("partnershipprogram"),
      buttonText: t("join"),
      image: img5,
      url:
        authData?.userRoleType === userTypes.PARTNER_ROLE
          ? "/contract"
          : "https://www.trive.com/",
      target: authData?.userRoleType === userTypes.PARTNER_ROLE ? "" : "_blank",
    },
  ];
  const hasMultipleSlides = campaignSliderDatas.length > 1;

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active",
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  const closeMenu = () => {
    if (isSidebarOpen) {
      document.documentElement.setAttribute("data-sidebar-size", "sm");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "lg");
    }
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <SimpleBar id="scrollbar" className="h-100">
          <div className="navbar-brand-box-sidebar">
            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img src={logoSm} alt="trive-logo" height="50" />
              </span>
              <span className="logo-lg">
                <img
                  src={isInvest ? logoInvestDark : logoTriveLight}
                  alt="trive-logo"
                  height={`${isInvest ? "36" : "80"}`}
                />
              </span>
            </Link>

            <button
              onClick={addEventListenerOnSmHoverMenu}
              type="button"
              className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
              id="vertical-hover"
            >
              <RiRecordCircleLine size={20} />
            </button>
          </div>

          <React.Fragment>
            <div className="mt-3">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout
                    layoutType={layoutType}
                    isSidebarOpen={isSidebarOpen}
                    dir={dir}
                  />
                </ul>

                {!isInvest ? (
                  <Swiper
                    pagination={{ clickable: true }}
                    className="mySwiper swiper default-swiper rounded mx-2"
                    modules={[Autoplay, Pagination]}
                    loop={hasMultipleSlides}
                    autoplay={hasMultipleSlides ? { delay: 5000 } : false}
                  >
                    <div className="swiper-wrapper my-3">
                      {campaignSliderDatas.map((data) => (
                        <SwiperSlide key={`swiper-wrapper-${data.id}`}>
                          <CampaignCard
                            isSidebarOpen={isSidebarOpen}
                            data={data}
                          />
                        </SwiperSlide>
                      ))}
                    </div>
                  </Swiper>
                ) : null}
              </Container>
            </div>
            <div className="sidebar-background"></div>
          </React.Fragment>
        </SimpleBar>
        <Button color="primary" className="menu-closer" onClick={closeMenu}>
          {isSidebarOpen ? (
            dir === "rtl" ? (
              <RiArrowRightSLine />
            ) : (
              <RiArrowLeftSLine />
            )
          ) : dir === "rtl" ? (
            <RiArrowLeftSLine />
          ) : (
            <RiArrowRightSLine />
          )}
        </Button>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
